/**
 * Shows a one-time toast the first time the user goes offline,
 * informing them that they can keep working — the app will sync later.
 */
import { useEffect, useRef } from 'react'
import toast from 'react-hot-toast'
import { useNetworkStatus } from '@/hooks/useNetworkStatus'

const SEEN_KEY = 'antiplanning.offlineDiscoverySeen'

export default function OfflineDiscoveryToast() {
  const { isOffline } = useNetworkStatus()
  const shownRef = useRef(false)

  useEffect(() => {
    if (!isOffline || shownRef.current) return
    const seen = localStorage.getItem(SEEN_KEY) === 'true'
    if (seen) return
    shownRef.current = true
    localStorage.setItem(SEEN_KEY, 'true')
    toast(
      "Pas de réseau ? Vous pouvez continuer à travailler. La synchronisation se fera automatiquement à la reconnexion.",
      {
        duration: 8000,
        icon: '💡',
        style: {
          background: '#1e293b',
          color: 'white',
          maxWidth: 420,
        },
      }
    )
  }, [isOffline])

  return null
}
